import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { loadUser } from "../../store/userSlice";
import MobileWrapper from "../../components/MobileWrapper";
import {
  RiLockPasswordLine,
  RiLogoutCircleLine,
  RiUserLine,
  RiMailLine,
  RiPhoneLine,
  RiTeamLine,
  RiShieldUserLine,
} from "react-icons/ri";
import PasswordChangeModal from "../../components/SecurityComponents/PasswordChangeModal";

export default function SecurityProfile() {
  const currentUser = useSelector((state) => state.userObject);
  const dispatch = useDispatch();
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [passwordData, setPasswordData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
    showCurrentPassword: false,
    showNewPassword: false,
    showConfirmPassword: false,
  });

  // Format roles from array to display string
  const getRolesDisplay = () => {
    if (!currentUser?.roles || !currentUser.roles.length)
      return "No roles assigned";
    return currentUser.roles.join(", ");
  };

  const handleLogout = () => {
    dispatch(loadUser({}));
  };

  return (
    <MobileWrapper className="bg-gray-50" label="User Profile">
      <div className="px-4 py-5">
        {/* Profile Header */}
        <div className="bg-[#363062] rounded-lg p-5 mb-5 shadow-md relative overflow-hidden">
          <div className="absolute top-0 right-0 w-32 h-32 bg-[#8FCD00] opacity-10 rounded-full -mr-10 -mt-10"></div>
          <div className="absolute bottom-0 left-0 w-24 h-24 bg-[#8FCD00] opacity-10 rounded-full -ml-10 -mb-10"></div>

          <div className="flex items-center">
            <div className="h-16 w-16 rounded-full bg-[#8FCD00] flex items-center justify-center text-[#363062] text-xl font-bold shadow-md">
              {currentUser?.firstName?.[0] || currentUser?.email?.[0] || "U"}
            </div>
            <div className="ml-4 text-white">
              <h2 className="text-lg font-semibold">
                {currentUser?.firstName} {currentUser?.lastName}
              </h2>
              <p className="text-gray-200 text-sm flex items-center">
                <RiMailLine className="mr-1" />
                {currentUser?.email}
              </p>
            </div>
          </div>
        </div>

        {/* Account Information */}
        <div className="bg-white rounded-lg shadow-sm p-4 mb-4">
          <div className="flex items-center text-[#363062] mb-3">
            <RiShieldUserLine className="mr-2 text-[#8FCD00]" />
            <h3 className="text-base font-medium">Account Information</h3>
          </div>

          <div className="space-y-3">
            <div className="flex items-center justify-between border-b border-gray-100 pb-2">
              <span className="text-gray-500 flex items-center">
                <RiMailLine className="mr-2 text-[#8FCD00] text-sm" />
                Email
              </span>
              <span className="text-sm">
                {currentUser?.email || "Not provided"}
              </span>
            </div>
            <div className="flex items-center justify-between border-b border-gray-100 pb-2">
              <span className="text-gray-500 flex items-center">
                <RiPhoneLine className="mr-2 text-[#8FCD00] text-sm" />
                Phone
              </span>
              <span className="text-sm">
                {currentUser?.phone || "Not provided"}
              </span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-gray-500 flex items-center">
                <RiTeamLine className="mr-2 text-[#8FCD00] text-sm" />
                Role
              </span>
              <span className="text-sm">{getRolesDisplay()}</span>
            </div>
          </div>
        </div>

        {/* Security Options */}
        <div className="bg-white rounded-lg shadow-sm p-4 mb-5">
          <div className="flex items-center text-[#363062] mb-3">
            <RiLockPasswordLine className="mr-2 text-[#8FCD00]" />
            <h3 className="text-base font-medium">Security</h3>
          </div>

          <button
            className="w-full py-2.5 my-1 text-[#363062] bg-gray-50 border border-gray-200 rounded-md flex items-center justify-center hover:bg-gray-100 transition-colors"
            onClick={() => setShowPasswordModal(true)}
          >
            <RiLockPasswordLine className="mr-2 text-[#8FCD00]" />
            Change Password
          </button>
        </div>

        {/* Logout Button */}
        <button
          className="w-full py-3 bg-[#363062] text-white font-medium rounded-md hover:bg-opacity-90 transition-colors flex items-center justify-center shadow-sm"
          onClick={handleLogout}
        >
          <RiLogoutCircleLine className="mr-2" />
          Log Out
        </button>
      </div>

      {showPasswordModal && (
        <PasswordChangeModal
          onClose={() => setShowPasswordModal(false)}
          passwordData={passwordData}
          setPasswordData={setPasswordData}
          loading={loading}
          setLoading={setLoading}
        />
      )}
    </MobileWrapper>
  );
}
